module.exports = __webpack_public_path__ + "static/img/axures-small-copy.473e3ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Gotit/axures-small-copy.png
// module id = nr34
// module chunks = 0